/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';
import {
  questionDialogFormInitial,
  choiceTemplateDialogFormInitial,
  hookDialogFormInitial,
  matrixChoiceDialogFormInitial,
} from './initial-state';
import initialState from './state';

export default {
  // eslint-disable-next-line
  [types.RESET_SURVEYBUILDER]: state => {
    Object.assign(state, initialState());
  },

  // TABS
  [types.SET_TAB_ACTIVE]: (state, payload) => {
    state.tabActive = payload;
    window.scrollTo(0, 0);
  },

  // DASHBOARD
  [types.SET_SURVEY_FILTER]: (state, payload) => {
    state.surveyListFilter = payload;
  },
  [types.SET_SURVEY_ACTIVE]: (state, id) => {
    state.surveyList = state.surveyList.map(survey => {
      if (survey.id === id) {
        return { ...survey, isActive: true };
      }
      return survey;
    });
  },
  [types.SET_SURVEY_INACTIVE]: (state, id) => {
    state.surveyList = state.surveyList.map(survey => {
      if (survey.id === id) {
        return { ...survey, isActive: false };
      }
      return survey;
    });
  },
  [types.SET_SURVEY_FAVORITE]: (state, data) => {
    state.surveyList = state.surveyList.map(survey => {
      if (survey.id === data.id) {
        return { ...survey, favorite: data.favorite };
      }
      return survey;
    });
  },
  [types.SET_SURVEY_SORT_BY_FAVORITE]: state => {
    state.surveyList = state.surveyList.sort((a, b) => {
      if (a.favorite === b.favorite) {
        return 0;
      } else if (a.favorite) {
        return -1;
      }
      return 1;
    });
  },
  [types.SET_SURVEY_DELETE]: (state, data) => {
    state.surveyList = state.surveyList.filter(survey => survey.id !== data.id);
  },

  // CANVAS
  [types.ADD_CANVAS_QUESTION]: (state, payload) => {
    state.canvasQuestions = [...state.canvasQuestions, payload];
  },
  [types.SELECT_CANVAS_QUESTION_ID]: (state, payload) => {
    state.canvasSelectedQuestionId = payload;
  },
  [types.SET_CANVAS_QUESTIONS]: (state, payload) => {
    state.canvasQuestions = payload;
  },

  // SELECTORS
  [types.SELECT_SELECTOR_QUESTION_CATEGORY]: (state, payload) => {
    state.selectorSelectedQuestionCategory = payload;
  },
  [types.SELECT_SELECTOR_TEMPLATE_ID]: (state, payload) => {
    state.selectorSelectedTemplateId = payload;
  },
  [types.SELECT_SELECTOR_TEMPLATE_CATEGORY]: (state, payload) => {
    state.selectorSelectedTemplateCategory = payload;
  },
  [types.SELECT_SELECTOR_CHOICE_CATEGORY]: (state, payload) => {
    state.selectorSelectedChoiceCategory = payload;
  },
  [types.SET_SELECTOR_QUESTION_TEXT]: (state, payload) => {
    state.selectorQuestionSearchText = payload;
  },
  [types.SET_SELECTOR_TEMPLATE_TEXT]: (state, payload) => {
    state.selectorTemplateSearchText = payload;
  },
  [types.SET_SELECTOR_CHOICE_TEXT]: (state, payload) => {
    state.selectorChoiceSearchText = payload;
  },
  [types.SET_SELECTOR_HOOK_TEXT]: (state, payload) => {
    state.selectorHookSearchText = payload;
  },
  [types.SET_SELECTOR_MATRIX_CHOICE_TEXT]: (state, payload) => {
    state.selectorMatrixChoiceSearchText = payload;
  },
  [types.RESET_SELECTOR_QUESTION_FILTERS]: state => {
    state.selectorSelectedQuestionCategory = null;
    state.selectorQuestionSearchText = '';
  },
  [types.RESET_SELECTOR_TEMPLATE_FILTERS]: state => {
    state.selectorSelectedTemplateCategory = null;
    state.selectorTemplateSearchText = '';
    state.selectorSelectedChoiceCategory = null;
    state.selectorSelectedTemplateId = null;
  },
  [types.RESET_SELECTOR_CHOICE_FILTERS]: state => {
    state.selectorSelectedChoiceCategory = null;
    state.selectorChoiceSearchText = '';
  },
  [types.RESET_SELECTOR_HOOK_FILTERS]: state => {
    state.selectorHookSearchText = '';
  },
  [types.RESET_SELECTOR_MATRIX_CHOICE_FILTERS]: state => {
    state.selectorMatrixChoiceSearchText = '';
  },
  //
  // QUESTIONS
  [types.SET_QUESTION_DIALOG_VISIBILITY]: (state, payload) => {
    state.questionDialogVisible = payload;
  },
  [types.SET_QUESTION_DIALOG_ADD_TO_CANVAS]: (state, payload) => {
    state.questionDialogAddToCanvas = payload;
  },
  [types.SET_QUESTION_DIALOG_FORM]: (state, payload) => {
    state.questionDialogForm = payload;
  },
  [types.RESET_QUESTION_DIALOG_FORM]: state => {
    state.questionDialogForm = { ...questionDialogFormInitial };
  },

  // QUESTION CONDITIONAL LOGIC
  [types.SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_VISIBILITY]: (state, payload) => {
    state.questionConditionalLogicDialogVisible = payload;
  },
  [types.SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_QUESTION]: (state, payload) => {
    state.questionConditionalLogicDialogQuestion = payload;
  },

  // HOOKS
  [types.SET_HOOK_DIALOG_VISIBILITY]: (state, payload) => {
    state.hookDialogVisible = payload;
  },
  [types.SET_HOOK_DIALOG_FORM]: (state, payload) => {
    state.hookDialogForm = payload;
  },
  [types.RESET_HOOK_DIALOG_FORM]: state => {
    state.hookDialogForm = { ...hookDialogFormInitial };
  },

  // MATRIX CHOICES
  [types.SET_MATRIX_CHOICE_DIALOG_VISIBILITY]: (state, payload) => {
    state.matrixChoiceDialogVisible = payload;
  },
  [types.SET_MATRIX_CHOICE_DIALOG_FORM]: (state, payload) => {
    state.matrixChoiceDialogForm = payload;
  },
  [types.RESET_MATRIX_CHOICE_DIALOG_FORM]: state => {
    state.matrixChoiceDialogForm = { ...matrixChoiceDialogFormInitial };
  },

  // MATRIX CONDITIONAL LOGIC
  [types.SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_VISIBILITY]: (state, payload) => {
    state.matrixConditionalLogicDialogVisible = payload;
  },
  [types.SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_MATRIX_CHOICE]: (state, payload) => {
    state.matrixConditionalLogicDialogMatrixChoice = payload;
  },

  // CHOICE TEMPLATES
  [types.SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY]: (state, payload) => {
    state.choiceTemplateDialogVisible = payload;
  },
  [types.SET_CHOICE_TEMPLATE_DIALOG_CHOICES]: (state, payload) => {
    state.choiceTemplateDialogChoices = payload;
  },
  [types.SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE]: (state, payload) => {
    state.choiceTemplateDialogIsScale = payload;
  },
  [types.SET_CHOICE_TEMPLATE_DIALOG_FORM]: (state, payload) => {
    state.choiceTemplateDialogForm = payload;
  },
  [types.RESET_CHOICE_TEMPLATE_DIALOG_FORM]: state => {
    state.choiceTemplateDialogForm = { ...choiceTemplateDialogFormInitial };
  },

  // QUESTION CATEGORIES
  [types.CREATE_QUESTION_CATEGORY]: (state, payload) => {
    state.questionCategoryList = [...state.questionCategoryList, payload];
  },
  [types.SET_QUESTION_CATEGORY_DIALOG_VISIBILITY]: (state, payload) => {
    state.questionCategoryDialogVisible = payload;
  },

  // CHOICE CATEGORIES
  [types.SET_CHOICE_CATEGORY_DIALOG_VISIBILITY]: (state, payload) => {
    state.choiceCategoryDialogVisible = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/surveybuilder/mutations.js